import { createFileRoute } from '@tanstack/react-router'

import { getInvoicesPageContent } from '#/modules/invoice/front-office/invoices-page/invoices-page-content.ts'
import { InvoicesPageSkeleton } from '#/modules/invoice/front-office/invoices-page/invoices-page-skeleton.tsx'
import { InvoicesPage } from '#/modules/invoice/front-office/invoices-page/invoices-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/invoices-v2')({
  beforeLoad: ({ context }) => requirePermissions(context, ['invoice.read']),
  loader: async ({ context }) => {
    const { queryClient, trpc } = context
    // Secondary block (the "receive invoices by email" checkbox) fetches independent, argument-free
    // data. Warm it here so it runs in parallel with the blocking query below instead of
    // starting a second serial network round once the page mounts. Not awaited — never delays first paint.
    void queryClient.prefetchQuery(trpc.notificationsConfiguration.getMyNotificationsConfiguration.queryOptions())

    const invoices = await queryClient.ensureQueryData(trpc.invoices.listMyInvoices.queryOptions())

    // The next-invoice card shows the payment method of that invoice's contract. Warm it once the
    // invoice list is known so the card renders with the method already resolved (no in-card flash).
    const subscriptionId = getInvoicesPageContent(invoices).nextInvoice?.invoice.subscriptionId
    if (subscriptionId !== undefined) {
      await queryClient.ensureQueryData(trpc.paymentMethod.getBySubscriptionId.queryOptions({ subscriptionId }))
    }
  },
  pendingComponent: InvoicesPageSkeleton,
  pendingMs: 150,
  component: InvoicesPage,
})
